
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { WizEventManager } from '@wizeoo/akm-component-lib';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AlkEvent } from '../../../events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../model/enums';

// TODO TODO supprimer, utilisé unique par vue Incex

/**
 * renderer d'une colonne avec icone close pour le ag-grid
 */
@Component({
  selector: 'ag-action-delete-renderer',
  template: `<wiz-hgroup
    height="100%"
    width="100%"
    verticalAlign="center"
    horizontalAlign="center"
    [wizDisabled]="!canDelete"
  >
  <wiz-icon  [wizTooltip]="'$.common.delete.$'" (click)="doDelete($event)">delete</wiz-icon>  
  </wiz-hgroup>`,
  styles: [':host {height:100%; width: 100%; max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgActionDeleteRenderer implements AgRendererComponent {
  data: any;

  feature: string;

  constructor(private cdref: ChangeDetectorRef, private elementRef: ElementRef) {}

  public refresh(params: ICellRendererParams): boolean {
    this.data = params.data;
    this.feature = (params as any).feature;
    this.cdref.markForCheck();
    return true;
  }

  public agInit(params: ICellRendererParams) {
    this.data = params.data;
    this.feature = (params as any).feature;
    this.cdref.markForCheck();
  }

  get canDelete(): boolean {
    // if (!this.feature) {
    //   return true;
    // }
    return true;
  }

  /**
   * emission d'un evenement de suppression
   * @param event wizevent
   */
  public doDelete(event: Event): void {
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.DELETE, this.data, this));
  }
}
